module.exports = __webpack_public_path__ + "img/guarani-sign.ea89cc0a.svg";